export const FORM_NAMES = {
    loginForm: "loginForm",
};
